import React, { useEffect } from 'react';
import ReviewIntegritySystem from '../components/ReviewIntegritySystem';

export default function ReviewIntegrityPage() {
  useEffect(() => {
    document.body.classList.add('analytics-page');
    return () => {
      document.body.classList.remove('analytics-page');
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', paddingTop: '60px' }}>
      <ReviewIntegritySystem isStaffView={true} />
    </div>
  );
}